<template>
  <section class="invite-section">
    <div class="list-group-container">
      <div class="d-flex flex-row list-row-header">
        <div class="p-2 w-50 first-column">Name</div>
        <div class="p-2 w-20">Role</div>
        <div class="p-2 w-20">Actions</div>
      </div>

      <!-- appears if with role/s -->
      <div class="list-rows">
        <div v-for="(data, index) in roles" :key="index" class="d-flex flex-row list-row">
          <div class="p-2 w-50 list-column-item first-column">
            <p>{{ toTitleCase(data.individual_details.profile_details.full_name) }}</p>
          </div>

          <div class="p-2 list-column-item">
            <p>{{ toTitleCase(data.role_in_company) }}</p>
          </div>

          <div class="p-2 list-column-action">
            <button class="simple-link" @click="editRole(data, $event)">
              <i class="fas fa-edit"></i>
            </button>
          </div>
          <div class="p-2 list-column-action">
            <button class="simple-link" @click="deleteRole(data, $event)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- end with roles -->
    </div>
    <!--end list group-->
  </section>
</template>

<script>
import '@/assets/styles/list-style.css'

export default {
  name: 'roles-list-view',
  data() {
    return { }
  },
  props: {
    roles: Array,
    editRole: Function,
    deleteRole: Function,
    toTitleCase: Function
  }
}
</script>

<style scoped>
.invite-section {
  margin-top: 48px;
  width: 95%;
}
.invite-status-header {
  display:flex;
  align-items: center;
}
.invite-status-title {
  font-family: "HKGrotesk-Bold", Helvetica, sans-serif;
  color: #00386A;
  font-size: 20px;
}
.invite-status-indicator {
  width: 12px;
  height: 12px;

  border-radius: 100%;
  margin-right: 12px;
}

/* Status indicator color styles */
.status-active {
  background-color: #42BB79;
}
.status-inactive {
  background-color: #547181;
}
.status-pending {
  background-color: #EDC834;
}

/* list row header */
.list-row-header .p-2, .list-column-item {
  margin: 0px;
}

/deep/.first-column {
  margin: 0px 16px !important;
}

/deep/.simple-link {
  padding: 0px !important;
}

/* Media Small Screen */

@media (max-width: 568px) {
  .invite-section {
    margin-top: 20px;
    width: 85%;
    margin-left: auto;
    margin-right: auto;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/listview/RolesListView.vue